const heroArrow = document.querySelector('.hero-arrow span');
if ( heroArrow ) {
    heroArrow.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const heroBlock = document.querySelector('.site-hero + *');
        heroBlock.scrollIntoView({behavior: "smooth"});
    })
}

